<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd"
    d="M18.1747 19.8316L20.1255 17.8808C20.6877 17.3185 21.0038 16.5552 21.0038 15.7589V6.99825C21.0038 4.78833 19.2121 2.99658 17.0022 2.99658H6.998C4.78808 2.99658 2.99634 4.78833 2.99634 6.99825V17.0024C2.99634 19.2123 4.78808 21.0041 6.998 21.0041H15.3445C16.4059 21.0041 17.4233 20.5829 18.1747 19.8316Z"
    stroke="inherit" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M15.0012 21.004V17.0023C15.0012 15.8968 15.8966 15.0015 17.0021 15.0015H21.0037" stroke="inherit"
    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  <path d="M14 9L10.876 14L9 10.9996" stroke="inherit" stroke-width="1.5" stroke-linecap="round"
    stroke-linejoin="round" />
</svg>
